import React from 'react';

import { ActionButtonProps, CancelButtonProps, FormButtonProps } from './props';

const Button: React.FC<ActionButtonProps> = ({ onClick, className, children,type ,disabled = false}) => {
  return (
    <button
      onClick={onClick}
      className={`${className} rounded-lg text-base  font-bold text-white bg-iconBg `}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export default Button;

export const AddButton: React.FC<ActionButtonProps> = ({ onClick, className, children,type }) => {
  return (
    <button
      onClick={onClick}
      className={`${className} h-11 w-11 rounded-full bg-iconBg text-white shadow-6 text-3xl text-center shadow-iconShadow`}
      type={type}
    >
      <p className='mb-[2px]'>
      {children}
      </p>
    </button>
  );
}

export const FormButton: React.FC<FormButtonProps> = ({ className, children,type }) => {
  return (
    <button
      className={`${className} rounded-lg text-base font-bold text-white bg-iconBg  `}
      type={type}
    >
      {children}
    </button>
  );
}


export const CancelButton: React.FC<CancelButtonProps> = ({ onClick, className, children }) => {
  return (
    <button
      onClick={onClick}
      className={`${className} border border-border rounded-lg text-base font-bold text-black bg-white hover:bg-gray-200`}
      type="button"
    >
      {children}
    </button>
  );
}

